class SomiRanking extends HTMLElement {
  connectedCallback() {
    if (this.events) return;
    this.events = new AbortController();
    this.tabs = [...this.querySelectorAll('[data-ranking-tab]')];
    this.panels = [...this.querySelectorAll('[data-ranking-panel]')];
    if (!this.tabs.length) return;
    this.querySelector('.somi-ranking__tabs').setAttribute('role', 'tablist');
    this.tabs.forEach((tab, index) => {
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', tab.dataset.panel);
      const panel = this.panels[index];
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', tab.id);
      tab.addEventListener('click', event => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault(); this.select(index);
      }, {signal:this.events.signal});
      tab.addEventListener('keydown', event => {
        if (event.key === ' ') { event.preventDefault(); this.select(index); return; }
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault(); this.tabs[next].focus({preventScroll:true});
        this.tabs[next].scrollIntoView({block:'nearest', inline:'nearest'}); this.select(next);
      }, {signal:this.events.signal});
    });
    this.select(0, false);
    this.observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) { this.load(0); this.observer.disconnect(); }
    }, {rootMargin:'240px'});
    this.observer.observe(this);
    this.addEventListener('shopify:block:select', event => {
      const index = this.tabs.findIndex(tab => tab.dataset.panel.endsWith(`-${event.detail.blockId}`));
      if (index >= 0) this.select(index);
    }, {signal:this.events.signal});
  }
  select(index, load = true) {
    this.tabs.forEach((tab, i) => {
      tab.classList.toggle('is-active', i === index);
      tab.setAttribute('aria-selected', String(i === index));
      tab.tabIndex = i === index ? 0 : -1;
      this.panels[i].hidden = i !== index;
    });
    if (load) this.load(index);
  }
  async load(index) {
    const panel = this.panels[index];
    if (panel.dataset.loaded || panel.getAttribute('aria-busy') === 'true') return;
    panel.setAttribute('aria-busy', 'true');
    const timeout = new AbortController();
    const timer = setTimeout(() => timeout.abort(), 12000);
    const abort = () => timeout.abort();
    this.events.signal.addEventListener('abort', abort, {once:true});
    try {
      const url = new URL(this.tabs[index].href);
      if (url.origin !== window.location.origin) throw new Error('Invalid collection origin');
      url.searchParams.set('section_id', 'somi-ranking-products');
      const response = await fetch(url, {signal:timeout.signal});
      if (!response.ok) throw new Error('Ranking request failed');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const products = doc.querySelector('[data-ranking-products][data-sort="best-selling"]');
      if (!products) throw new Error('Ranking not available');
      if (!this.isConnected) return;
      panel.replaceChildren(products);
      panel.dataset.loaded = 'true';
    } catch (error) {
      const message = panel.querySelector('.somi-ranking__message');
      if (message && this.isConnected) message.textContent = '商品一覧から人気アイテムをご覧いただけます。';
    } finally {
      clearTimeout(timer);
      this.events?.signal.removeEventListener('abort', abort);
      panel.setAttribute('aria-busy', 'false');
    }
  }
  disconnectedCallback() {
    this.observer?.disconnect(); this.events?.abort(); this.events = null;
  }
}
if (!customElements.get('somi-ranking')) customElements.define('somi-ranking', SomiRanking);
